<template>
	<div class="login_box">
		<div class="login_content">
			<img src="../../assets/img/login/logo.png" class="login_logo" />
			<div class="login_left">
				<img src="../../assets/img/login/login_img.png" />
			</div>
			<div class="login_right">
				<h1>欢迎使用兰州文理学院<br>继续教育学习平台</h1>
				<span>
					<p>手机号<span style="color: red;">*</span></p>
					<input type="text" v-model="loginName" placeholder="请输入手机号" maxlength="18" />
				</span>
				<span>
					<p>登录密码<span style="color: red;">*</span></p>
					<input type="password" v-model="password" placeholder="请输入登录密码" maxlength="18" />
				</span>
				<span>
					<p>选择年份<span style="color: red;">*</span></p>
					 <select v-model="year" placeholder="请选择选择年份" class="year" @change="selectClass($event)">
						<option value="2026">2026年</option>
						<option value="2025">2025年</option>
						<option value="2024">2024年</option>
					    <option value="2023">2023年</option>
					    <option value="2022">2022年</option>  
						<option value="2021">2021年</option>  
						<option value="2020">2020年</option>  
					</select>
				</span>
				<a @click="toRegister" style="float: right;">立即注册</a>
				<button @click="toLogin">立即登录</button>
			</div>
		</div>
		<div class="clear"></div>
	</div>
</template>

<script>
	import {
		encrypt,
		decrypt
	} from '../../config/jsencrypt'
	import http from '@/utils/http.js'
	import common from '@/config/common.js'
	import {
		login
	} from '@/api/login.js'
	export default {
		data() {
			return {
				password: null,
				loginName: null,
				year:2024
			}
		},
		methods: {
			selectClass(event){
				if(event.target.value != null && event.target.value != ''){
					this.year = event.target.value;
				}else{
					this.year = null;
				}
			},
			toRegister() {
				let routeData = this.$router.resolve({
				    name: 'register'
				})
				window.open(routeData.href, '_blank')
				//this.$router.push('/register');
			},
			toLogin() {
				if (this.loginName == null || this.loginName == '') {
					this.$message.error('请输入账号！');
					return;
				}
				if (this.password == null || this.password == '') {
					this.$message.error('请输入密码！');
					return;
				}
				if (this.year == null || this.year == '') {
					this.$message.error('请选择培训年份！');
					return;
				}
				var jm_password = null;
				jm_password = encrypt(this.password)
				if (jm_password == null || jm_password == '') {
					this.$message.error('密码错误');
					return;
				}
				var parm = {
					'loginName': this.loginName,
					'password': jm_password,
					'year': this.year
				};
				login(parm).then(res => {
					console.log("JSON.stringify(obj)" + res + JSON.stringify(res));
					if (res.code == 200) {
						this.$message.success('登录成功');
						localStorage.setItem('year', this.year);
						localStorage.setItem('token', res.data.token);
						localStorage.setItem('login_time', res.data.login_time);
						localStorage.setItem('expire_time', res.data.expire_time);
						localStorage.setItem('user_mobile', res.data.user_mobile);
						localStorage.setItem('user_name', res.data.user_name);
						localStorage.setItem('id_card', res.data.id_card);
                        localStorage.setItem('user_img', res.data.user_img);
						localStorage.setItem('loginstate', true);
						this.$router.push('/');
					} else {
						this.$message.error('登录信息错误');
					}
				})


			}
		}
	}
</script>

<style lang="less" scoped>
	.year {
	  width: 100%;
	  height:38px;
	  outline:none;
	  border:none ;
	  border-bottom: 0.01852rem solid #d7d7d7;
	  font-size:16px
	}
	.login_box {
		width: 100%;
		height: 100vh;
		background: url(../../assets/img/login/wsgrxx.jpg) no-repeat;
		background-size: 100% 100%;
		padding: 10vh 10%;
		box-sizing: border-box;

		.login_content {
			width: 100%;
			height: 100%;
			border-radius: 50px;
			background: #fff;
			padding: 30px 50px;
			box-sizing: border-box;

			.login_logo {
				width: auto;
				height: 70px;
				display: block;
			}

			.login_left {
				width: 55%;
				height: calc(100% - 80px);
				display: inline-block;
				float: left;

				img {
					width: auto;
					height: 85%;
					margin-top: 5%;
					display: block;
					margin: 5% auto 0 auto;
				}
			}

			.login_right {
				width: 41%;
				margin-left: 4%;
				margin-bottom: 60px;
				height: calc(100% - 130px);
				display: inline-block;
				float: left;
				display: flex;
				align-items: center;
				flex-wrap: wrap;

				h1 {
					width: 100%;
					height: auto;
					line-height: 50px;
					font-weight: bold;
					color: #2961EF;
					font-size: 32px;
					margin-bottom: 10px;
				}

				span {
					width: 70%;
					height: auto;
					display: inline-block;

					p {
						width: 100%;
						height: 30px;
						line-height: 30px;
						display: inline-block;
						font-size: 16px;
						color: #909090;
					}

					input {
						width: 100%;
						height: 35px;
						line-height: 35px;
						border: none;
						border-bottom: 1px solid #d7d7d7;
						font-size: 18px;
						color: #333;
					}
				}

				a {
					width: 70%;
					height: auto;
					line-height: 40px;
					display: inline-block;
					text-align: right;
					color: #2961EF;
					font-size: 16px;
				}

				button {
					width: 70%;
					height: 45px;
					border-radius: 60px;
					background: linear-gradient(to right, #4076FF, #2961EF);
					font-size: 16px;
					color: #fff;
					border: none;
				}
			}
		}
	}
</style>
